import moment from "moment";

const activatedToday = (data, reportDate) => {
  if (!Array.isArray(data)) return 0;
  const today = moment(reportDate).format("YYYY-MM-DD");

  return data?.filter((item) => {
    if (!item?.activated_at) return false;
    return moment(item?.activated_at).format("YYYY-MM-DD") === today;
  })?.length;
};

export default activatedToday;
